/** THE LIVE PLAYERS BOARD'S LOOK — resolved in ONE place.
 *
 *  The board on a player's phone and the live preview on the control page both
 *  call this, so what an owner sees while designing is what players get. Every
 *  value may be empty, and empty means "the board as it looks today": the
 *  screen's own colours, fonts and the venue logo already in use.
 */
import { bodyFontSize, fontStack, headlineFontSize } from './designTokens';

/** STADIUM DARK — the board's look when the owner has set nothing of their own.
 *  Every one of these is still overridden by whatever is saved in Board design. */
export const STADIUM = {
    bg: '#0E1117',
    card: '#1A202C',
    cardHigh: '#222938',
    border: '#2D3748',
    bubble: '#1E2638',
    text: '#F8FAFC',
    meta: '#94A3B8',
    accent: '#E11D48',
    gold: '#F59E0B',
    silver: '#CBD5E1',
    bronze: '#B45309',
    header: '/board/arena-dark.jpg',
};

export const boardSkin = (brand, c = {}, ty = {}, lang = 'en', fallbackLogo = null) => {
    const b = brand?.board || {};
    const words = b.watermark_text || {};
    const headline = headlineFontSize(b.headline_size, null, 24);
    const body = bodyFontSize(b.body_size, null, 14);

    return {
        bg: b.bg || STADIUM.bg,
        text: b.text || c.text || STADIUM.text,
        accent: b.accent || STADIUM.accent,
        // Unset = today's row: a hairline border and no fill of its own.
        bubble: b.bubble || null,
        // Stadium Dark surfaces. A saved bubble colour still wins.
        card: b.bubble || STADIUM.card,
        cardHigh: b.bubble || STADIUM.cardHigh,
        chatBubble: b.bubble || STADIUM.bubble,
        border: STADIUM.border,
        meta: STADIUM.meta,
        gold: STADIUM.gold,
        silver: STADIUM.silver,
        bronze: STADIUM.bronze,
        headerImage: STADIUM.header,
        headlineStyle: {
            ...(ty.headline || {}),
            ...(b.headline_font ? { fontFamily: fontStack(b.headline_font) } : {}),
            ...(headline ? { fontSize: headline } : {}),
        },
        bodyStyle: {
            ...(ty.body || {}),
            ...(b.body_font ? { fontFamily: fontStack(b.body_font) } : {}),
            ...(body ? { fontSize: body } : {}),
        },
        logoUrl: b.logo_url || fallbackLogo || null,
        logoSize: b.logo_size_px || null,
        logo2Url: b.logo2_url || null,
        logo2Size: b.logo2_size_px || null,
        wallpaperUrl: b.wallpaper_url || null,
        wallpaperOverlay: b.wallpaper_overlay == null ? 45 : b.wallpaper_overlay,
        watermarkUrl: b.watermark_url || null,
        watermarkText: words[lang] || words.en || '',
        watermarkCorner: b.watermark_position === 'corner',
        watermarkSize: b.watermark_size || 55,
        watermarkOpacity: (b.watermark_opacity == null ? 10 : b.watermark_opacity) / 100,
        bannerBg: b.banner_bg || null,
        bannerText: b.banner_text || null,
        bannerSize: b.banner_text_size || null,
        bannerImage: b.banner_image_url || null,
    };
};

export const boardAbs = (url) => (!url ? null
    : (String(url).startsWith('http') ? url
        : `${typeof window !== 'undefined' ? window.location.origin : ''}${url}`));

export default boardSkin;
